import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import AppRoute from './routes/AppRoute';
import Snackbar from './components/common/SnackbarMessage';
import useDisableRightClick from './hooks/useDisableRightClick';
import { ISLIVE } from './utils/base-urls';

const App = () => {
    useDisableRightClick(ISLIVE); 


    return (
        <> 
            <Router>
                <Routes>
                    <Route path='*' element={<AppRoute />} />
                </Routes>
            </Router>
            <Snackbar />
        </>
    )
}

export default App;